<div class="itsl-course-info-box__content">
    <div class="itsl-course-info-box__header">
        <h2 class="itsl-course-info-box__title">{config.courseTitle}</h2>
        {#if config.hasCoursePermissionAdministrateCalendar && config.courseType === courseType.InformationHub}
            <div class="itsl-course-info-box__actions">
                <ButtonGroup>
                    <Link kind="standalone" iconClass="new-event-icon" label={newEventLabel} href={newEventUrl} />
                </ButtonGroup>
            </div>
        {/if}
    </div>
    <div
        class="itsl-course-info-box__description"
        class:itsl-course-info-box__description--empty={descriptionIsEmpty}
    >
        <SimpleRtfEditor
            headingLevel={defaultEditorHeadingLevel}
            i18n={getSimpleRtfEditorI18n()}
            label={lang.main("Course_info_box_Course_description")}
            labelHidden
            readOnly
            showSkipLink={false}
            bind:this={rtfEditor}
        />
    </div>
    {#if config.displayShowTeachers && config.showTeachers}
        <CourseInfoBoxTeachers
            courseTeachersTitle={lang.main("Course_info_box_course_teachers")}
        />
    {/if}
    {#if config.canAdminGeneral}
        <Link kind="secondary-standalone" href={config.editPageUrl}>{lang.main("Edit")}</Link>
    {/if}
</div>

<script>
    import { onMount } from "svelte";
    import CourseInfoBoxTeachers from "./CourseInfoBoxTeachers.svelte";
    import ButtonGroup from "@itslearning/prometheus/assets/inputs/ButtonGroup/v1/ButtonGroup.svelte";
    import Link from "@itslearning/prometheus/assets/navigation/Link/v1/Link.svelte";
    import SimpleRtfEditor from "@itslearning/prometheus/assets/nodes/SimpleRtfEditor/v1/SimpleRtfEditor.svelte";
    import { getSimpleRtfEditorI18n } from "@its-ui/mono/lang/pack/simpleRtfEditor";
    import { lang } from "@its-ui/mono/lang/provider";

    import config from "../../config";
    import { courseType, defaultEditorHeadingLevel } from "../../constants";
    import { isEmptyRtfContent, setRtfContent } from "../../utils";

    const newEventUrl = config.newEventUrl;
    const newEventLabel = lang.main("CreateEvent");

    /** @type {SimpleRtfEditor} */
    let rtfEditor;

    $: descriptionIsEmpty = isEmptyRtfContent(rtfEditor);

    onMount(() => setRtfContent(rtfEditor, config.courseDescription));
</script>
